import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';
import PersonAddOutlinedIcon from '@material-ui/icons/PersonAddOutlined';
import ShoppingCartOutlinedIcon from '@material-ui/icons/ShoppingCartOutlined';
import CreditCard from '../../icons/credit-card';
import QrCode from '../../icons/qr-code';
import UploadLogIcon from '../../icons/upload-log';

export enum GcpVerticalTabComponent {
  Dashboard = 'Dashboard',
  Transactions = 'Transactions',
  CreateQR = 'CreateQR',
  BillerEnrollment = 'BillerEnrollment',
  PaymentFile = 'PaymentFile',
  Invitation = 'Invitation',
  Directory = 'Directory',
}

export const mainMenu = [
  {
    id: 1,
    icon: ShoppingCartOutlinedIcon,
    stage: GcpVerticalTabComponent.Transactions,
    translation: 'appbar.transactions',
  },
  {
    id: 2,
    icon: QrCode,
    stage: GcpVerticalTabComponent.CreateQR,
    translation: 'appbar.qr',
  },
];

export const recurringRequestMenu = [
  {
    id: 3,
    icon: CreditCard,
    stage: GcpVerticalTabComponent.BillerEnrollment,
    translation: 'appbar.biller_enrollment',
  },
];

export const paymentRequestMenu = [
  {
    id: 4,
    icon: UploadLogIcon,
    stage: GcpVerticalTabComponent.PaymentFile,
    translation: 'appbar.payment_file',
  },
];

export const userMenu = [
  {
    id: 5,
    icon: PersonAddOutlinedIcon,
    stage: GcpVerticalTabComponent.Invitation,
    translation: 'appbar.invite_user',
  },
  {
    id: 6,
    icon: PeopleOutlineIcon,
    stage: GcpVerticalTabComponent.Directory,
    translation: 'appbar.user_directory',
  },
];
